//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.1.0 (NJsonSchema v11.5.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class GeneratedClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    appsettings( cancelToken?: CancelToken): Promise<MapSettingsResponse> {
        let url_ = this.baseUrl + "/api/appsettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAppsettings(_response);
        });
    }

    protected processAppsettings(response: AxiosResponse): Promise<MapSettingsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MapSettingsResponse.fromJS(resultData200);
            return Promise.resolve<MapSettingsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MapSettingsResponse>(null as any);
    }

    /**
     * @return Success
     */
    brands(cou: Country, local: Country, cancelToken?: CancelToken): Promise<BrandsResponse> {
        let url_ = this.baseUrl + "/api/brands?";
        if (cou === undefined || cou === null)
            throw new globalThis.Error("The parameter 'cou' must be defined and cannot be null.");
        else
            url_ += "cou=" + encodeURIComponent("" + cou) + "&";
        if (local === undefined || local === null)
            throw new globalThis.Error("The parameter 'local' must be defined and cannot be null.");
        else
            url_ += "local=" + encodeURIComponent("" + local) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBrands(_response);
        });
    }

    protected processBrands(response: AxiosResponse): Promise<BrandsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BrandsResponse.fromJS(resultData200);
            return Promise.resolve<BrandsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BrandsResponse>(null as any);
    }

    /**
     * @return Success
     */
    cooperationArea(cou: Country, local: Country, cancelToken?: CancelToken): Promise<CooperationAreasResponse> {
        let url_ = this.baseUrl + "/api/cooperation-area?";
        if (cou === undefined || cou === null)
            throw new globalThis.Error("The parameter 'cou' must be defined and cannot be null.");
        else
            url_ += "cou=" + encodeURIComponent("" + cou) + "&";
        if (local === undefined || local === null)
            throw new globalThis.Error("The parameter 'local' must be defined and cannot be null.");
        else
            url_ += "local=" + encodeURIComponent("" + local) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCooperationArea(_response);
        });
    }

    protected processCooperationArea(response: AxiosResponse): Promise<CooperationAreasResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CooperationAreasResponse.fromJS(resultData200);
            return Promise.resolve<CooperationAreasResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CooperationAreasResponse>(null as any);
    }

    /**
     * @return Success
     */
    cooperationSubarea(cou: Country, local: Country, cancelToken?: CancelToken): Promise<CooperationSubAreasResponse> {
        let url_ = this.baseUrl + "/api/cooperation-subarea?";
        if (cou === undefined || cou === null)
            throw new globalThis.Error("The parameter 'cou' must be defined and cannot be null.");
        else
            url_ += "cou=" + encodeURIComponent("" + cou) + "&";
        if (local === undefined || local === null)
            throw new globalThis.Error("The parameter 'local' must be defined and cannot be null.");
        else
            url_ += "local=" + encodeURIComponent("" + local) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCooperationSubarea(_response);
        });
    }

    protected processCooperationSubarea(response: AxiosResponse): Promise<CooperationSubAreasResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CooperationSubAreasResponse.fromJS(resultData200);
            return Promise.resolve<CooperationSubAreasResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CooperationSubAreasResponse>(null as any);
    }

    /**
     * @param language (optional) 
     * @return Success
     */
    geocodeAddress(address: string, language: string | undefined, cancelToken?: CancelToken): Promise<GeocodeAddressResponse> {
        let url_ = this.baseUrl + "/api/geocode-address?";
        if (address === undefined || address === null)
            throw new globalThis.Error("The parameter 'address' must be defined and cannot be null.");
        else
            url_ += "address=" + encodeURIComponent("" + address) + "&";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeocodeAddress(_response);
        });
    }

    protected processGeocodeAddress(response: AxiosResponse): Promise<GeocodeAddressResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeocodeAddressResponse.fromJS(resultData200);
            return Promise.resolve<GeocodeAddressResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeocodeAddressResponse>(null as any);
    }

    /**
     * @param language (optional) 
     * @return Success
     */
    geocodeGeomtry(latitude: string, longitude: string, language: string | undefined, cancelToken?: CancelToken): Promise<GeocodeGeomtryResponse> {
        let url_ = this.baseUrl + "/api/geocode-geomtry?";
        if (latitude === undefined || latitude === null)
            throw new globalThis.Error("The parameter 'latitude' must be defined and cannot be null.");
        else
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === undefined || longitude === null)
            throw new globalThis.Error("The parameter 'longitude' must be defined and cannot be null.");
        else
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeocodeGeomtry(_response);
        });
    }

    protected processGeocodeGeomtry(response: AxiosResponse): Promise<GeocodeGeomtryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeocodeGeomtryResponse.fromJS(resultData200);
            return Promise.resolve<GeocodeGeomtryResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeocodeGeomtryResponse>(null as any);
    }

    /**
     * @return Success
     */
    partnerFilter(cou: Country, local: Country, vehicleRegistrationNumber: string, cancelToken?: CancelToken): Promise<PartnerFilterResponse> {
        let url_ = this.baseUrl + "/api/partnerFilter?";
        if (cou === undefined || cou === null)
            throw new globalThis.Error("The parameter 'cou' must be defined and cannot be null.");
        else
            url_ += "cou=" + encodeURIComponent("" + cou) + "&";
        if (local === undefined || local === null)
            throw new globalThis.Error("The parameter 'local' must be defined and cannot be null.");
        else
            url_ += "local=" + encodeURIComponent("" + local) + "&";
        if (vehicleRegistrationNumber === undefined || vehicleRegistrationNumber === null)
            throw new globalThis.Error("The parameter 'vehicleRegistrationNumber' must be defined and cannot be null.");
        else
            url_ += "vehicleRegistrationNumber=" + encodeURIComponent("" + vehicleRegistrationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartnerFilter(_response);
        });
    }

    protected processPartnerFilter(response: AxiosResponse): Promise<PartnerFilterResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PartnerFilterResponse.fromJS(resultData200);
            return Promise.resolve<PartnerFilterResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnerFilterResponse>(null as any);
    }

    /**
     * @param coopAreas (optional) 
     * @param coopSubAreas (optional) 
     * @return Success
     */
    partners(licensePlate: string, country: Country, language: Country, lat: number, lng: number, coopAreas: number[] | undefined, coopSubAreas: number[] | undefined, cancelToken?: CancelToken): Promise<PartnersResponse> {
        let url_ = this.baseUrl + "/api/partners?";
        if (licensePlate === undefined || licensePlate === null)
            throw new globalThis.Error("The parameter 'licensePlate' must be defined and cannot be null.");
        else
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (country === undefined || country === null)
            throw new globalThis.Error("The parameter 'country' must be defined and cannot be null.");
        else
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (language === undefined || language === null)
            throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (lat === undefined || lat === null)
            throw new globalThis.Error("The parameter 'lat' must be defined and cannot be null.");
        else
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (lng === undefined || lng === null)
            throw new globalThis.Error("The parameter 'lng' must be defined and cannot be null.");
        else
            url_ += "lng=" + encodeURIComponent("" + lng) + "&";
        if (coopAreas === null)
            throw new globalThis.Error("The parameter 'coopAreas' cannot be null.");
        else if (coopAreas !== undefined)
            coopAreas && coopAreas.forEach(item => { url_ += "coopAreas=" + encodeURIComponent("" + item) + "&"; });
        if (coopSubAreas === null)
            throw new globalThis.Error("The parameter 'coopSubAreas' cannot be null.");
        else if (coopSubAreas !== undefined)
            coopSubAreas && coopSubAreas.forEach(item => { url_ += "coopSubAreas=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartners(_response);
        });
    }

    protected processPartners(response: AxiosResponse): Promise<PartnersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PartnersResponse.fromJS(resultData200);
            return Promise.resolve<PartnersResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnersResponse>(null as any);
    }

    /**
     * @return Success
     */
    partnerTypes(cou: Country, local: Country, cancelToken?: CancelToken): Promise<PartnerTypesResponse> {
        let url_ = this.baseUrl + "/api/partner-types?";
        if (cou === undefined || cou === null)
            throw new globalThis.Error("The parameter 'cou' must be defined and cannot be null.");
        else
            url_ += "cou=" + encodeURIComponent("" + cou) + "&";
        if (local === undefined || local === null)
            throw new globalThis.Error("The parameter 'local' must be defined and cannot be null.");
        else
            url_ += "local=" + encodeURIComponent("" + local) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartnerTypes(_response);
        });
    }

    protected processPartnerTypes(response: AxiosResponse): Promise<PartnerTypesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PartnerTypesResponse.fromJS(resultData200);
            return Promise.resolve<PartnerTypesResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnerTypesResponse>(null as any);
    }

    /**
     * @return Success
     */
    serviceTypes(cou: Country, local: Country, cancelToken?: CancelToken): Promise<ServiceTypesResponse> {
        let url_ = this.baseUrl + "/api/service-types?";
        if (cou === undefined || cou === null)
            throw new globalThis.Error("The parameter 'cou' must be defined and cannot be null.");
        else
            url_ += "cou=" + encodeURIComponent("" + cou) + "&";
        if (local === undefined || local === null)
            throw new globalThis.Error("The parameter 'local' must be defined and cannot be null.");
        else
            url_ += "local=" + encodeURIComponent("" + local) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processServiceTypes(_response);
        });
    }

    protected processServiceTypes(response: AxiosResponse): Promise<ServiceTypesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceTypesResponse.fromJS(resultData200);
            return Promise.resolve<ServiceTypesResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceTypesResponse>(null as any);
    }
}

export class Brand implements IBrand {
    id?: number;
    name?: string | undefined;

    constructor(data?: IBrand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Brand {
        data = typeof data === 'object' ? data : {};
        let result = new Brand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IBrand {
    id?: number;
    name?: string | undefined;
}

export class BrandsResponse implements IBrandsResponse {
    status?: string | undefined;
    data?: Brand[] | undefined;

    constructor(data?: IBrandsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Brand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BrandsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BrandsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBrandsResponse {
    status?: string | undefined;
    data?: Brand[] | undefined;
}

export class CooperationArea implements ICooperationArea {
    id?: number;
    name?: string | undefined;

    constructor(data?: ICooperationArea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CooperationArea {
        data = typeof data === 'object' ? data : {};
        let result = new CooperationArea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICooperationArea {
    id?: number;
    name?: string | undefined;
}

export class CooperationAreasResponse implements ICooperationAreasResponse {
    status?: string | undefined;
    data?: CooperationArea[] | undefined;

    constructor(data?: ICooperationAreasResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CooperationArea.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CooperationAreasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CooperationAreasResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICooperationAreasResponse {
    status?: string | undefined;
    data?: CooperationArea[] | undefined;
}

export class CooperationSubArea implements ICooperationSubArea {
    id?: number;
    areaId?: number;
    name?: string | undefined;

    constructor(data?: ICooperationSubArea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.areaId = _data["areaId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CooperationSubArea {
        data = typeof data === 'object' ? data : {};
        let result = new CooperationSubArea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["areaId"] = this.areaId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICooperationSubArea {
    id?: number;
    areaId?: number;
    name?: string | undefined;
}

export class CooperationSubAreasResponse implements ICooperationSubAreasResponse {
    status?: string | undefined;
    data?: CooperationSubArea[] | undefined;

    constructor(data?: ICooperationSubAreasResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CooperationSubArea.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CooperationSubAreasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CooperationSubAreasResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICooperationSubAreasResponse {
    status?: string | undefined;
    data?: CooperationSubArea[] | undefined;
}

export class Coordinates implements ICoordinates {
    countryCode?: string | undefined;
    lat?: string | undefined;
    lng?: string | undefined;

    constructor(data?: ICoordinates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
        }
    }

    static fromJS(data: any): Coordinates {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        return data;
    }
}

export interface ICoordinates {
    countryCode?: string | undefined;
    lat?: string | undefined;
    lng?: string | undefined;
}

export enum Country {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class GeocodeAddressResponse implements IGeocodeAddressResponse {
    status?: string | undefined;
    data?: any | undefined;

    constructor(data?: IGeocodeAddressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): GeocodeAddressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GeocodeAddressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data;
        return data;
    }
}

export interface IGeocodeAddressResponse {
    status?: string | undefined;
    data?: any | undefined;
}

export class GeocodeGeomtryResponse implements IGeocodeGeomtryResponse {
    status?: string | undefined;
    data?: any | undefined;

    constructor(data?: IGeocodeGeomtryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): GeocodeGeomtryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GeocodeGeomtryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data;
        return data;
    }
}

export interface IGeocodeGeomtryResponse {
    status?: string | undefined;
    data?: any | undefined;
}

export class Information implements IInformation {
    subnetwork?: number | undefined;
    notes?: string[] | undefined;

    constructor(data?: IInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subnetwork = _data["subnetwork"];
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(item);
            }
        }
    }

    static fromJS(data: any): Information {
        data = typeof data === 'object' ? data : {};
        let result = new Information();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subnetwork"] = this.subnetwork;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item);
        }
        return data;
    }
}

export interface IInformation {
    subnetwork?: number | undefined;
    notes?: string[] | undefined;
}

export class Location implements ILocation {
    latitude?: number;
    longitude?: number;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface ILocation {
    latitude?: number;
    longitude?: number;
}

export class MapSettings implements IMapSettings {
    googleApiKey?: string | undefined;
    defaultCountry?: string | undefined;
    defaultLanguage?: string | undefined;
    coordinates?: Coordinates[] | undefined;

    constructor(data?: IMapSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.googleApiKey = _data["googleApiKey"];
            this.defaultCountry = _data["defaultCountry"];
            this.defaultLanguage = _data["defaultLanguage"];
            if (Array.isArray(_data["coordinates"])) {
                this.coordinates = [] as any;
                for (let item of _data["coordinates"])
                    this.coordinates!.push(Coordinates.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MapSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MapSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["googleApiKey"] = this.googleApiKey;
        data["defaultCountry"] = this.defaultCountry;
        data["defaultLanguage"] = this.defaultLanguage;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMapSettings {
    googleApiKey?: string | undefined;
    defaultCountry?: string | undefined;
    defaultLanguage?: string | undefined;
    coordinates?: Coordinates[] | undefined;
}

export class MapSettingsResponse implements IMapSettingsResponse {
    status?: string | undefined;
    data?: MapSettings;

    constructor(data?: IMapSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"] ? MapSettings.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): MapSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MapSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IMapSettingsResponse {
    status?: string | undefined;
    data?: MapSettings;
}

export class Partner implements IPartner {
    id?: number;
    latitude?: number;
    longitude?: number;
    distance?: number;
    openingHours?: string | undefined;
    name?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    zip?: string | undefined;
    email?: string | undefined;
    gsm?: string | undefined;
    website?: string | undefined;
    colorCode?: string | undefined;
    colorName?: string | undefined;
    servicesCollection?: Service[] | undefined;

    constructor(data?: IPartner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.distance = _data["distance"];
            this.openingHours = _data["openingHours"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.zip = _data["zip"];
            this.email = _data["email"];
            this.gsm = _data["gsm"];
            this.website = _data["website"];
            this.colorCode = _data["colorCode"];
            this.colorName = _data["colorName"];
            if (Array.isArray(_data["servicesCollection"])) {
                this.servicesCollection = [] as any;
                for (let item of _data["servicesCollection"])
                    this.servicesCollection!.push(Service.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Partner {
        data = typeof data === 'object' ? data : {};
        let result = new Partner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["distance"] = this.distance;
        data["openingHours"] = this.openingHours;
        data["name"] = this.name;
        data["city"] = this.city;
        data["street"] = this.street;
        data["zip"] = this.zip;
        data["email"] = this.email;
        data["gsm"] = this.gsm;
        data["website"] = this.website;
        data["colorCode"] = this.colorCode;
        data["colorName"] = this.colorName;
        if (Array.isArray(this.servicesCollection)) {
            data["servicesCollection"] = [];
            for (let item of this.servicesCollection)
                data["servicesCollection"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPartner {
    id?: number;
    latitude?: number;
    longitude?: number;
    distance?: number;
    openingHours?: string | undefined;
    name?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    zip?: string | undefined;
    email?: string | undefined;
    gsm?: string | undefined;
    website?: string | undefined;
    colorCode?: string | undefined;
    colorName?: string | undefined;
    servicesCollection?: Service[] | undefined;
}

export class PartnerFilter implements IPartnerFilter {
    brands?: number[] | undefined;
    cooperationAreas?: number[] | undefined;
    cooperationSubAreas?: number[] | undefined;
    ids?: number[] | undefined;
    location?: Location;
    radius?: number | undefined;
    services?: number[] | undefined;
    types?: number[] | undefined;
    subnetworks?: number[] | undefined;

    constructor(data?: IPartnerFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["brands"])) {
                this.brands = [] as any;
                for (let item of _data["brands"])
                    this.brands!.push(item);
            }
            if (Array.isArray(_data["cooperationAreas"])) {
                this.cooperationAreas = [] as any;
                for (let item of _data["cooperationAreas"])
                    this.cooperationAreas!.push(item);
            }
            if (Array.isArray(_data["cooperationSubAreas"])) {
                this.cooperationSubAreas = [] as any;
                for (let item of _data["cooperationSubAreas"])
                    this.cooperationSubAreas!.push(item);
            }
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : undefined as any;
            this.radius = _data["radius"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(item);
            }
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            if (Array.isArray(_data["subnetworks"])) {
                this.subnetworks = [] as any;
                for (let item of _data["subnetworks"])
                    this.subnetworks!.push(item);
            }
        }
    }

    static fromJS(data: any): PartnerFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.brands)) {
            data["brands"] = [];
            for (let item of this.brands)
                data["brands"].push(item);
        }
        if (Array.isArray(this.cooperationAreas)) {
            data["cooperationAreas"] = [];
            for (let item of this.cooperationAreas)
                data["cooperationAreas"].push(item);
        }
        if (Array.isArray(this.cooperationSubAreas)) {
            data["cooperationSubAreas"] = [];
            for (let item of this.cooperationSubAreas)
                data["cooperationSubAreas"].push(item);
        }
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["radius"] = this.radius;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item);
        }
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        if (Array.isArray(this.subnetworks)) {
            data["subnetworks"] = [];
            for (let item of this.subnetworks)
                data["subnetworks"].push(item);
        }
        return data;
    }
}

export interface IPartnerFilter {
    brands?: number[] | undefined;
    cooperationAreas?: number[] | undefined;
    cooperationSubAreas?: number[] | undefined;
    ids?: number[] | undefined;
    location?: Location;
    radius?: number | undefined;
    services?: number[] | undefined;
    types?: number[] | undefined;
    subnetworks?: number[] | undefined;
}

export class PartnerFilterResponse implements IPartnerFilterResponse {
    status?: string | undefined;
    data?: PartnerFilter;

    constructor(data?: IPartnerFilterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"] ? PartnerFilter.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): PartnerFilterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerFilterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IPartnerFilterResponse {
    status?: string | undefined;
    data?: PartnerFilter;
}

export class PartnerType implements IPartnerType {
    id?: number;
    name?: string | undefined;

    constructor(data?: IPartnerType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PartnerType {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPartnerType {
    id?: number;
    name?: string | undefined;
}

export class PartnerTypesResponse implements IPartnerTypesResponse {
    status?: string | undefined;
    data?: PartnerType[] | undefined;

    constructor(data?: IPartnerTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PartnerType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartnerTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPartnerTypesResponse {
    status?: string | undefined;
    data?: PartnerType[] | undefined;
}

export class Partners implements IPartners {
    totalCount?: number;
    partnersCollection?: Partner[] | undefined;

    constructor(data?: IPartners) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["partnersCollection"])) {
                this.partnersCollection = [] as any;
                for (let item of _data["partnersCollection"])
                    this.partnersCollection!.push(Partner.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Partners {
        data = typeof data === 'object' ? data : {};
        let result = new Partners();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.partnersCollection)) {
            data["partnersCollection"] = [];
            for (let item of this.partnersCollection)
                data["partnersCollection"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPartners {
    totalCount?: number;
    partnersCollection?: Partner[] | undefined;
}

export class PartnersResponse implements IPartnersResponse {
    status?: string | undefined;
    data?: Partners;

    constructor(data?: IPartnersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"] ? Partners.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): PartnersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PartnersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IPartnersResponse {
    status?: string | undefined;
    data?: Partners;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class Service implements IService {
    serviceType?: number;
    information?: Information[] | undefined;

    constructor(data?: IService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceType = _data["serviceType"];
            if (Array.isArray(_data["information"])) {
                this.information = [] as any;
                for (let item of _data["information"])
                    this.information!.push(Information.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Service {
        data = typeof data === 'object' ? data : {};
        let result = new Service();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceType"] = this.serviceType;
        if (Array.isArray(this.information)) {
            data["information"] = [];
            for (let item of this.information)
                data["information"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IService {
    serviceType?: number;
    information?: Information[] | undefined;
}

export class ServiceType implements IServiceType {
    id?: number;
    name?: string | undefined;

    constructor(data?: IServiceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ServiceType {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IServiceType {
    id?: number;
    name?: string | undefined;
}

export class ServiceTypesResponse implements IServiceTypesResponse {
    status?: string | undefined;
    data?: ServiceType[] | undefined;

    constructor(data?: IServiceTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ServiceType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IServiceTypesResponse {
    status?: string | undefined;
    data?: ServiceType[] | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}